import { render, staticRenderFns } from "./Fantasylive.vue?vue&type=template&id=43e22434&scoped=true&"
import script from "./Fantasylive.vue?vue&type=script&lang=js&"
export * from "./Fantasylive.vue?vue&type=script&lang=js&"
import style0 from "./Fantasylive.vue?vue&type=style&index=0&id=43e22434&prod&scoped=true&lang=css&"
import style1 from "./Fantasylive.vue?vue&type=style&index=1&id=43e22434&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e22434",
  null
  
)

export default component.exports